import { put } from "redux-saga/effects";
import { logoutSagaAC, addNotificationAC } from "./systemActionCreators";

export function* errorGenerator(response: any) {
  if (response.status === 401) {
    yield put(logoutSagaAC());
  } else {
    if (response.status !== 403) {
      const id = new Date();

      const message =
        response?.data?.description ||
        response?.data?.message ||
        "ERROR_SERVER_CONNECTION";

      yield put(
        addNotificationAC({
          message,
          id: id.getTime().toString(),
        }),
      );
    }
  }
}

export function* notificationCreator(message: string) {
  const id = new Date();

  yield put(
    addNotificationAC({
      id: id.getTime().toString(),
      message: message,
    }),
  );
}
